import { fade, makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
    root: {
      flexGrow: 1,
      fontFamily: [
        'Montserrat', 
        'sans-serif',
      ].join(',')
    },
    toolbarRoot: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'row-reverse'
    },
    spacer: {
      flexGrow: 1,
      display: 'none',
      [theme.breakpoints.up('sm')]: {
        display: 'block',
      },
    },
    search: {
      display: 'flex',
      alignItems: 'center',
      backgroundColor: fade(theme.palette.common.white, 0.15),
      marginTop: '-23px',
      marginLeft: 0,
      marginRight: '10px',
      width: '100%',
      [theme.breakpoints.up('sm')]: {
        marginLeft: theme.spacing(1),
        width: 'auto',
      },
    },
    
    searchIcon: {
        marginRight: 5,
        display: 'flex',
        cursor: 'pointer',
        height: '100%',
        alignItems: 'center',
        justifyContent: 'center',
        '&:hover': {
            color: '#DC251A'
        }
    },
    inputRoot: {
      color: 'inherit',
      fontFamily: [
        'Montserrat', 
        'sans-serif',
      ].join(','),
      fontSize: 12,
    },
    inputShow: {
      padding: theme.spacing(1, 1, 1, 0),
      marginRight: 10,
      transition: theme.transitions.create('width'),
      width: '100%',
      width: '18ch',
      borderBottom: "1px solid black",
      '&::placeholder': {
        fontSize: '11px',
        opacity: 0.8,
      }
    },
    inputHide: {
      transition: theme.transitions.create('width'),
      borderBottom: "1px solid black",
      '&::placeholder': {
        fontSize: '11px',
        opacity: 0.8,
      },
      [theme.breakpoints.up('sm')]: {
        width: '0ch'
      }

    },
    hidePopup:{
      opacity: 0
    },
    showPopup: {
      opacity: 1
    },

    listbox: {
    fontFamily: [
        'Montserrat', 
        'sans-serif',
      ].join(','),
      fontSize: '12px',
      fontWeight: 500
    }
  }));
